export function getDataFromTextInput (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).val()
}

export function getDataFromList (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).val()
}

export function getDataFromBoolean (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).prop('indeterminate') == true ? null : $(buildSelectorForRecieving(attributeElementId, settings)).prop('checked')
}

export function getDataFromLabel (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).attr('value')
}

export function getDataFromImage (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).attr('src')
}

export function getDataFromImageUploader (attributeElementId, settings) {
	return $(buildSelectorForRecieving(attributeElementId, settings)).attr('data-image-token')
}

function buildSelectorForRecieving (id, settings) {
	var prefix = ''
	var postfix = ''
	if (settings) {
		if (settings['parentSelector']) prefix += (settings['parentSelector'] + ' ')
		if (settings['class']) postfix += ('.' + settings['class'])
	}
	return prefix + '#' + id + postfix
}
